import { render, staticRenderFns } from "./PortalServicesStep.vue?vue&type=template&id=5e461577&scoped=true"
import script from "./PortalServicesStep.vue?vue&type=script&lang=js"
export * from "./PortalServicesStep.vue?vue&type=script&lang=js"
import style0 from "./PortalServicesStep.vue?vue&type=style&index=0&id=5e461577&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e461577",
  null
  
)

export default component.exports